module.exports = __webpack_public_path__ + "static/media/iso-banner.639761f4.svg";